import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SearchFilter = ({ onSearch, stateCategory }) => {
  const [thunks, setThunks] = useState(null);
  const dispatch = useDispatch();
  const { searchTerm } = useSelector((state) => state[stateCategory]);

  const handleSearch = (e) => {
    dispatch(thunks?.setSearchTerm(e.target.value));
    onSearch();
  };

  useEffect(() => {
    onSearch();
  }, [searchTerm]);

  useEffect(() => {
    const loadThunks = async () => {
      let importedThunks;
      if (stateCategory === 'shortTermHousingRentals') {
        importedThunks = await import(
          '../store/slices/shortTermHousingRentals.slice'
        );
      }
      setThunks(importedThunks);
    };

    loadThunks();
  }, [stateCategory]);

  return (
    <div className='hide-mobile'>
      <input
        type='text'
        value={searchTerm}
        placeholder='Search by Name'
        className='form-control'
        onChange={(e) => handleSearch(e)}
      />
    </div>
  );
};

export default SearchFilter;
